import { cn } from "@/utils/cn";
import { IoIosArrowBack } from "@pkg/icons";

interface NavBackButtonProps {
  onClick: () => void;
}

/** Back arrow button for simplified navbars. */
export const NavBackButton: React.FC<NavBackButtonProps> = ({ onClick }) => {
  return (
    <button
      className={cn(
        "flex min-w-[100px] items-center gap-1 rounded-md border border-transparent py-1 pr-2 text-sm font-medium hover:border-lightGrey/40 active:scale-[98%] sm:gap-2 sm:text-base md:pr-4 md:pl-2 dark:text-white",
      )}
      onClick={onClick}
      aria-label="Back"
    >
      <IoIosArrowBack className="w-6" />
      Back
    </button>
  );
};
